class GzCosmeticModal extends HTMLElement {
  constructor() {
    super();
    this.buyBox = document.querySelector('product-info');
    this.conditionFieldSet = null;
    this.activeBuyBoxCondition = '';
    this.conditionDescriptions = {};
    this.imageUrls = {};
    this.currentSlideIndex = 0;
    this.modalOpen = false;
    this.init();
  }

  init() {
    this.initData();
    this.renderConditionElement();
    this.renderModal();
    this.updateSliderBasedOnCondition(this.activeBuyBoxCondition);
    this.addEventListeners();
  }

  initData() {
    this.conditionFieldSet = this.buyBox.querySelector("fieldset[name='Cosmetic Condition']");
    this.conditionDescriptions = JSON.parse(this.getAttribute('gz-data-cosmetic-modal-descriptions'));
    this.imageUrls = JSON.parse(this.getAttribute('gz-data-cosmetic-modal-images-2'));

    this.activeBuyBoxCondition = this.buyBox.querySelector("input[name='Cosmetic Condition']:checked").value;
    this.conditionToIndexMap = [...this.buyBox.querySelectorAll("input[name='Cosmetic Condition']")].reduce(
      (acc, input, index) => {
        acc[input.value] = index;
        return acc;
      },
      {},
    );
  }

  connectedCallback() {
    subscribe(PUB_SUB_EVENTS.variantChange, event => {
      const { option2: activeCondition } = event.data.variant;
      this.updateCurrentCondition(activeCondition);
    });
  }

  openModal() {
    document.body.style.overflow = 'hidden';
    const modalTitle = this.modal.querySelector('#gz-modal-title');
    modalTitle.textContent = `Cosmetic Conditions`;
    this.modalBackdrop.classList.add('show');
    this.modal.classList.add('show');
    this.modalOpen = true;
  }

  closeModal() {
    document.body.style.overflow = '';
    this.modalBackdrop.classList.remove('show');
    this.modal.classList.remove('show');
    this.modalOpen = false;
  }

  renderConditionElement() {
    const inputs = this.conditionFieldSet.querySelectorAll('input');
    let conditionValue = '';
    inputs.forEach(input => {
      if (input.checked) {
        conditionValue = input.value;
      }
    });

    const template = `
      <div id="selected-condition">
          <div class="content">
            <svg width="18" height="17" viewBox="0 0 18 17" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M9 16.5C6.125 16.5 3.5 15 2.0625 12.5C0.625 10.0312 0.625 7 2.0625 4.5C3.5 2.03125 6.125 0.5 9 0.5C11.8438 0.5 14.4688 2.03125 15.9062 4.5C17.3438 7 17.3438 10.0312 15.9062 12.5C14.4688 15 11.8438 16.5 9 16.5ZM7.75 11C7.3125 11 7 11.3438 7 11.75C7 12.1875 7.3125 12.5 7.75 12.5H10.25C10.6562 12.5 11 12.1875 11 11.75C11 11.3438 10.6562 11 10.25 11H10V8.25C10 7.84375 9.65625 7.5 9.25 7.5H7.75C7.3125 7.5 7 7.84375 7 8.25C7 8.6875 7.3125 9 7.75 9H8.5V11H7.75ZM9 4.5C8.4375 4.5 8 4.96875 8 5.5C8 6.0625 8.4375 6.5 9 6.5C9.53125 6.5 10 6.0625 10 5.5C10 4.96875 9.53125 4.5 9 4.5Z" fill="#FF6900"/>
            </svg>
            <span>What does ${conditionValue} look like?</span>
          </div>
      </div>
    `;

    this.appendChild(document.createElement('div'));
    this.innerHTML = template;
  }

  renderModal() {
    this.modalBackdrop = document.createElement('div');
    this.modalBackdrop.classList.add('gz-modal-backdrop');

    this.modal = document.createElement('div');
    this.modal.classList.add('gz-modal');

    const modalContent = `
      <div class="gz-modal-content">
        <div class="gz-modal-header">
          <h2 id="gz-modal-title">Cosmetic Conditions.</h2>
        </div>
          <button class="gz-modal-close close" aria-label="Close">
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M15.1719 2.42188L9.54688 8L15.125 13.5781L15.9219 14.375L14.375 15.9688L13.5781 15.1719L8 9.59375L2.42188 15.1719L1.625 15.9688L0.03125 14.375L0.828125 13.5781L6.40625 8L0.828125 2.42188L0.03125 1.625L1.625 0.03125L2.42188 0.828125L8 6.45312L13.5781 0.875L14.375 0.078125L15.9688 1.625L15.1719 2.42188Z" fill="#193154"/>
            </svg>
          </button>
        <div class="gz-modal-button-content"></div>
        <div style="padding: 0px 30px;" class="gz-modal-main-content">
          <div class="gz-modal-image-content">
            <div class="slider"></div>
            <div class="slider-nav">
              <button id="prev">
                <svg width="6" height="9" viewBox="0 0 6 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M4.81681 8.85359L5.52392 8.14649L1.87747 4.50004L5.52392 0.853592L4.81681 0.146484L0.463257 4.50004L4.81681 8.85359Z" fill="black"/>
                </svg>
              </button>
              <span id="slideIndex">1 / ${this.imageUrls[this.activeBuyBoxCondition].length}</span>
              <button id="next">
                <svg width="6" height="9" viewBox="0 0 6 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M1.17036 8.85359L0.463257 8.14649L4.1097 4.50004L0.463257 0.853592L1.17036 0.146484L5.52392 4.50004L1.17036 8.85359Z" fill="black"/>
                </svg>
              </button>
            </div>
          </div>
          <div class="gz-modal-description-content">
            <h3 class="gz-modal-description-title">Cosmetic Condition: <span id="current-condition">${
              this.activeBuyBoxCondition
            }</span></h3>
            <div class="gz-modal-description">${this.conditionDescriptions[this.activeBuyBoxCondition]}</div>
          </div>
        </div>
      </div>
    `;

    this.modal.innerHTML = modalContent;

    document.body.appendChild(this.modalBackdrop);
    document.body.appendChild(this.modal);

    this.renderModalButtons();
    this.renderSliderImages();

    this.closeButton = this.modal.querySelector('.close');
    this.closeButton.addEventListener('click', () => this.closeModal());
    this.modalBackdrop.addEventListener('click', () => this.closeModal());
  }

  renderSliderImages() {
    const slider = this.modal.querySelector('.slider');
    slider.innerHTML = '';

    const conditionImages = this.imageUrls[this.activeBuyBoxCondition];

    if (conditionImages) {
      conditionImages.forEach((url, index) => {
        const img = document.createElement('img');
        img.src = url;
        img.classList.add('slide');
        img.alt = `Slide ${index + 1}`;
        img.style.display = index === this.currentSlideIndex ? 'block' : 'none';
        slider.appendChild(img);
      });
      this.updateSlideIndex();
    }
  }

  showPreviousSlide() {
    const conditionImages = this.imageUrls[this.activeBuyBoxCondition];
    this.updateSliderState((this.currentSlideIndex - 1 + conditionImages.length) % conditionImages.length);
  }

  showNextSlide() {
    const conditionImages = this.imageUrls[this.activeBuyBoxCondition];
    this.updateSliderState((this.currentSlideIndex + 1) % conditionImages.length);
  }

  updateSliderState(index) {
    const slides = this.modal.querySelectorAll('.slide');
    slides[this.currentSlideIndex].style.display = 'none';
    this.currentSlideIndex = index;
    slides[this.currentSlideIndex].style.display = 'block';
    this.updateSlideIndex();
  }

  updateSlideIndex() {
    const conditionImages = this.imageUrls[this.activeBuyBoxCondition];
    const slideIndexSpan = this.modal.querySelector('#slideIndex');
    slideIndexSpan.textContent = `${this.currentSlideIndex + 1} / ${conditionImages.length}`;
  }

  updateSliderBasedOnCondition(condition) {
    if (this.imageUrls[condition]) {
      this.renderSliderImages();
    }
  }

  renderModalButtons() {
    const conditionInputValues = [...this.buyBox.querySelectorAll("input[name='Cosmetic Condition']")].map(
      input => input.value,
    );

    conditionInputValues.forEach(condition => {
      const button = document.createElement('button');
      button.textContent = condition;
      button.classList.add('gz-modal-button-secondary');
      if (this.activeBuyBoxCondition === condition) {
        button.classList.add('active');
      }
      button.addEventListener('click', () => this.updateCurrentCondition(condition));
      this.modal.querySelector('.gz-modal-button-content').appendChild(button);
    });
  }

  updateCurrentCondition(condition) {
    const span = this.querySelector('#selected-condition .content span');
    if (span) {
      span.textContent = `What does ${condition} look like?`;
    }
    const modalBtns = document.querySelectorAll('button.gz-modal-button-secondary');
    modalBtns.forEach(button =>
      button.innerHTML === condition ? button.classList.add('active') : button.classList.remove('active'),
    );

    this.activeBuyBoxCondition = condition;
    document.getElementById('current-condition').textContent = condition;
    document.querySelector('.gz-modal-description').textContent = this.conditionDescriptions[condition];
    this.updateSliderBasedOnCondition(condition);
  }

  addEventListeners() {
    const selectedCondition = this.querySelector('#selected-condition');
    const prevButton = this.modal.querySelector('#prev');
    const nextButton = this.modal.querySelector('#next');
    selectedCondition && selectedCondition.addEventListener('click', this.openModal.bind(this));
    prevButton && prevButton.addEventListener('click', () => this.showPreviousSlide());
    nextButton && nextButton.addEventListener('click', () => this.showNextSlide());
  }

  debug() {
    console.warn(`${this.constructor.name}: descriptions`, this.conditionDescriptions);
    console.warn(`${this.constructor.name}: images`, this.imageUrls);
    console.warn(`${this.constructor.name}: Buy Box`, this.buyBox);
    console.warn(`${this.constructor.name}: Condition Fieldset`, this.conditionFieldSet);
  }
}

customElements.define('gz-cosmetic-modal', GzCosmeticModal);
